import Resource from '@/services/resources/common';

export default class StructureTypeResource extends Resource {
  constructor(entrypoint = '/structure_types', alias = 'StructureType') {
    super(entrypoint, alias);
  }
}
